import Joi from 'joi'
import {inputStringValidation, textAreaValidation} from 'validation'

export const createKnowledgebaseSchema = Joi.object({
  name: inputStringValidation.min(3).required().messages({
    'string.empty': `Name cannot be an empty field`,
    'any.required': `Name cannot be an empty field`,
    'string.min': `Name length must be greater than or equal to 3 characters`,
    'string.max': `Name length must be less than or equal to 20 characters`,
  }),
  detail: textAreaValidation.allow('').max(150).messages({
    'string.max': `Description length must be less than or equal to 150 characters`,
  }),
})

export const generalSettingSchema = Joi.object({
  docsVisible: Joi.boolean(),
  id: Joi.number(),
  language: Joi.string(),
  name: Joi.string().trim().min(3).max(20).required().messages({
    'string.empty': `Name cannot be an empty field`,
    'any.required': `Name cannot be an empty field`,
    'string.min': `Name length must be greater than or equal to 3 characters`,
    'string.max': `Name length must be less than or equal to 20 characters`,
  }),
  cname: Joi.string()
    .pattern(
      /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})(\/[a-zA-Z0-9-_]*)*\/?$/
    )
    .message('Please enter a valid domain or URL.')
    .allow('', null),
})

export const advanceSettingSchema = Joi.object({
  docId: Joi.number(),
  isActive: Joi.boolean(),
  isAttachment: Joi.boolean(),
  isCaptcha: Joi.boolean(),
  isEmail: Joi.boolean(),
  isMessage: Joi.boolean(),
  isName: Joi.boolean(),
  isNumber: Joi.boolean(),
  isSubject: Joi.boolean(),
  mailboxId: Joi.number().allow(null, ''),
  submitButton: Joi.string().allow('', null),
  submitMessage: Joi.string().allow('', null),
  ticketHeading: Joi.string().allow('', null),
})

export const seoSettingsSchema = Joi.object({
  id: Joi.number(),
  anonymizedIp: Joi.boolean().allow(null),
  gaKey: Joi.string()
    .regex(/\d{4,10}-\d{1,4}\b/)
    .allow(null)
    .required()
    .label('Google Analytics Key'),
  seoTitle: Joi.string().trim().min(3).max(70).required().messages({
    'string.empty': `seoTitle cannot be an empty field`,
    'any.required': `seoTitle cannot be an empty field`,
    'string.min': `seoTitle length must be greater than or equal to 3 characters`,
    'string.max': `seoTitle length must be less than or equal to 70 characters`,
  }),
  seoDescription: Joi.string().trim().min(3).max(160).required().messages({
    'string.empty': `seoDescription cannot be an empty field`,
    'any.required': `seoDescription cannot be an empty field`,
    'string.min': `seoDescription length must be greater than or equal to 3 characters`,
    'string.max': `seoDescription length must be less than or equal to 160 characters`,
  }),
})

export const rulesSchema = Joi.object({
  source: Joi.string()
    .regex(/^\/\d+-[\w-]+\/\d+-[\w-]+$/)
    .messages({
      'string.pattern.base': 'Enter a valid source',
      'string.empty': 'source is not allowed to be empty',
    })
    .required(),
  destination: Joi.string()
    .regex(/^\/\d+-[\w-]+\/\d+-[\w-]+$/)
    .messages({
      'string.pattern.base': 'Enter a valid destination',
      'string.empty': 'destination is not allowed to be empty',
    })

    .required(),
})

export const externalKnowledgebaseSchema = Joi.object({
  docId: Joi.number(),
  importFrom: Joi.string().label('Platform'),
  importURL: Joi.string().uri().label('Import Url'),
})
